<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.groupService') }}</div>
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['code', 'desc']"
                  :selected-index-field-value="searchParams.groupService"
                  :rows="groupServiceOptions"
                  :columns="groupServiceOptionsCols"
                  :value="searchParams.bookingGroup"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectBookingGroup"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span v-if="selectedData?.code && selectedData?.desc">
                        {{ selectedData.code }} -
                        {{ selectedData.desc }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div> -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIds"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <!-- <div class="laundry-report__wrapper"> -->
    <div class="content-box report-grid-container">
      <div class="section-box outline">
        <div class="das-form-container" style="flex: 1">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"> Báo cáo tổng hợp miễn phí </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />
          <!-- <div class="das-form-title-container mt-20">
              <div class="das-form-title">
                <span class="sub-title"> Giặt là </span>
              </div>
            </div> -->

          <div v-loading="loading" class="collapse-grid__list">
            <el-collapse v-model="collapseNameList">
              <div
                v-for="laundryData in laundryDataList"
                :key="laundryData.hotel_id"
                class="collapse-grid__item"
              >
                <el-collapse-item :name="laundryData.hotel_id">
                  <template slot="title">
                    <span class="collapse-grid__item-header">
                      {{ 'Khách sạn:' }} {{ laundryData.hotel_name }}
                    </span>
                  </template>
                  <div class="grid-scroll" style="height: 400px">
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="laundryData.rows"
                      :is-row-selectable="isRowSelectable"
                      class="agGrid collapse-grid__agGrid"
                      dom-layout="scroll"
                      :auto-size-cell="true"
                      :full-width-cell-renderer="fullWidthCellRenderer"
                      :embed-full-width-rows="true"
                    />
                    <!-- :pinned-bottom-row-data="pinnedBottomRowData" -->
                  </div>
                </el-collapse-item>

                <div class="collapse-grid__item-footer">
                  {{ 'Tổng' }}: {{ $displayCurrency(laundryData.total) }}
                </div>
              </div>
            </el-collapse>
          </div>

          <hr style="margin-top: 14px" />
          <div class="total-price">
            Tổng: {{ $displayCurrency(totalAmount) }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="content-box">
      <LaundryPieChartReport />
    </div>
    <div class="content-box">
      <div class="section-box outline">
        <search-comp>
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.fromDate') }}</div>
                    <CalendarSelect mode="date" />
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.toDate') }}</div>
                    <CalendarSelect mode="date" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"> Biểu đồ Histogram </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- </div> -->

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <h3 class="note-title">Bảng dữ liệu</h3>
            <ul>
              <li>
                Khách sạn: Hiển thị tên khách sạn phát sinh phòng miễn phí
              </li>
              <li>
                Ngày: Liệt kê ngày có khách check in là phòng miễn phí trong
                khoảng thời gian tìm kiếm
              </li>
              <li>
                Hạng phòng: Hiển thị hạng phòng phát sinh đặt phòng miễn phí
              </li>
              <li>
                Số lượng phòng: Hiển thị tổng số lượng phòng của hạng phòng là
                đặt phòng miễn phí trong thời gian tìm kiếm
              </li>
              <li>
                Số đêm: Hiển thị tổng số đêm của tổng số đặt phòng miễn phí
              </li>
              <li>
                Tổng số tiền miễn phí: Hiển thị tổng số tiền miễn phí cho hạng
                phòng
              </li>
              <li>
                Tổng: Hiển thị tổng tiền của các hạng phòng phát sinh đặt phòng
                miễn phí theo ngày
              </li>
              <li>
                Tổng cộng: Hiển thị tổng tiền của khách sạn phát sinh hạng phòng
                miễn phí trong khoảng thời gian tìm kiếm
              </li>
              <li>
                Tổng tiền: Hiển thị tổng tiền miễn phí của tất cả các khách sạn
                được lọc trong khoảng thời gian tìm kiếm
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import FullWidthCellTransaction from './components/FullWidthCellTransaction.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel.js'
import {
  getSyntheticFreeList,
  getSyntheticFreeListExcel
} from '@/api/report_service/syntheticFreeRoom'
import moment from 'moment'
import { downFile } from '@/utils/file-handler'

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelIds: [],
  code: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    // eslint-disable-next-line vue/no-unused-components
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCellTransaction
  },
  data() {
    return {
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      groupServiceOptions: [],
      receptionistOptions: [],
      columns: [
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_code',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.numRoom'),
          field: 'total_rooms',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.sumMoneyFree'),
          field: 'total',
          cellRenderer: params => this.$displayCurrency(params.value),
          tooltipValueGetter: params => this.$displayCurrency(params.value),
          // cellClass: "grid-cell-centered",
          // width: 100,
          width: 200,
          sortable: false
        }
      ],
      rows: [
        {
          isFullWidthRow: true,
          billNumber: '123444',
          billDate: '05/12/2023',
          bookingCode: '12345',
          createdBy: 'ABC',
          roomNum: '127',
          total: '50000'
        },
        {
          col1: '2233',
          col2: 'Là hơi',
          col3: '100,000',
          col4: '1',
          col5: '0',
          col6: '100,000'
        },
        {
          col1: '2233',
          col2: 'Là hơi',
          col3: '100,000',
          col4: '1',
          col5: '0',
          col6: '100,000'
        },
        {
          isFullWidthRow: true,
          billNumber: '123444',
          billDate: '05/12/2023',
          bookingCode: '12345',
          createdBy: 'ABC',
          roomNum: '127',
          total: '50000'
        },
        // {
        //   isFullWidthRow: true,
        //   includeTaxFee: true,
        //   totalDiscount: '5000',
        //   totalBill: '45000',
        //   serviceFee: '0',
        //   taxFee: '0',
        //   billNum: '12345'
        // },
        {
          col1: '2233',
          col2: 'Là hơi',
          col3: '100,000',
          col4: '1',
          col5: '0',
          col6: '100,000'
        },
        {
          col1: '2233',
          col2: 'Là hơi',
          col3: '100,000',
          col4: '1',
          col5: '0',
          col6: '100,000'
        }
        // {
        //   service: 'Giặt là',
        //   totalServiceBill: '120,000',
        //   isFullWidthRow: true
        // }
      ],
      pinnedBottomRowData: [
        {
          col1: '335,000',
          isPinnedBottom: true
        }
      ],
      isRowSelectable: node => !node.data.isFullWidthRow,
      laundryDataList: [
        {
          id: 1,
          hotel_name: 'Test'
        },
        {
          id: 2,
          hotel_name: 'ABC'
        }
      ],
      collapseNameList: [],
      totalAmount: 0,

      loading: false
    }
  },
  beforeMount() {
    // GRID
  },
  mounted() {
    this.getHotelOptions()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    onSelectBookingGroup(data) {},

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },

    transferDataList(dataList) {
      const transferedDataList = []
      this.totalAmount = 0
      dataList.forEach(dataItem => {
        // Get FLAT array
        let dataRow = []
        dataItem.days.map(item => {
          dataRow = [
            ...dataRow,
            {
              isFullWidthRow: true,
              name: item.date
            },
            ...item.room_levels,
            {
              // isFullWidthRow: true,
              room_level_code: 'Tổng',
              total: item.total
            }
          ]
        })

        const transferedData = {
          hotel_id: dataItem.hotel_id,
          hotel_name: dataItem.hotel_name,
          total: dataItem.total,
          rows: dataRow
        }

        this.totalAmount += +dataItem.total

        transferedDataList.push(transferedData)

        // For Showing all item
        this.collapseNameList.push(dataItem.hotel_id)
      })

      return transferedDataList
    },

    attachData() {
      this.loading = true

      getSyntheticFreeList(this.searchParams)
        .then(res => {
          this.laundryDataList = this.transferDataList(res.data)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadExcel() {
      this.loading = true
      getSyntheticFreeListExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_tong_hop_mien_phi_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.agGrid {
  .ag-full-width-row {
    background-color: #fff !important;
  }
}

.total-price {
  font-weight: 600;
  text-align: right;
}

// .col-span-2 {
//   grid-column: span 2 / span 2;
// }

// .laundry-report__wrapper {
//   display: grid;
//   grid-template-columns: repeat(1, minmax(0, 1fr));
//   gap: 10px;
//   // flex-wrap: wrap;
//   // flex-direction: column;

//   .laundry-report__table-wrapper {
//     grid-column: 1 / span 1;
//   }

//   .content-box {
//     min-height: 600px;
//   }
// }

// @media only screen and (min-width: 1280px) {
//   .laundry-report__wrapper {
//     grid-template-columns: repeat(2, (minmax(0, 1fr)));

//     .laundry-report__table-wrapper {
//       grid-column: 1 / span 2;
//     }
//   }
// }
</style>

<style lang="scss">
.report-grid-container {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .collapse-grid__list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    // overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .collapse-grid__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .agGrid.collapse-grid__agGrid {
      .ag-header-viewport {
        background-color: var(--ag-header-bg) !important;
      }

      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.content-container .content-box .section-box.outline {
  height: auto !important;
  min-height: 100%;
}
</style>
